export const SUBMIT_REGISTER_LOADING = "SUBMIT_REGISTER_LOADING"
export const UPDATE_REGISTER_FORM = "UPDATE_REGISTER_OTP_FORM"